import type { useAuth } from '@virtuslab/react-oauth2';

import { isNotEmptyString } from './checks';
import type { Nullable } from './object';

type KeycloakAdapter = ReturnType<typeof useAuth>;

const getToken = async (auth: KeycloakAdapter) => {
  try {
    const token = await auth.getAccessToken();
    return token;
  } catch {
    return null;
  }
};

type AuthHeader = Readonly<{
  Authorization: string;
}>;

export const getAuthHeader = async (auth: KeycloakAdapter): Promise<Nullable<AuthHeader>> => {
  const token = await getToken(auth);

  return isNotEmptyString(token) ? { Authorization: `Bearer ${token}` } : null;
};

// Google always returns accounts.google.com; refusing anything else stops a compromised backend
// response from turning a redirect button into an open redirect.
export const isGoogleOAuthUrl = (url: string): boolean => {
  try {
    return new URL(url.trim()).origin === 'https://accounts.google.com';
  } catch {
    return false;
  }
};

